import { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Particles from "react-tsparticles";
import "./App.css";
import About from "./components/container/About";
import Home from "./components/container/Home";
import Navigation from "./components/presentational/Navigation";
import TopBar from "./components/presentational/TopBar";

let timeout = false; // holder for timeout id
function App() {
  const [screenWidth, setScreenWidth] = useState(window.innerHeight);
  const [screenHeight, setScreenHeight] = useState(window.innerWidth);
  const [expanded, setExpanded] = useState(false);
  const [showGameDesc, setShowGameDesc] = useState(true);
  const [showVideo, setShowVideo] = useState(true);
  const [showTangDesc, setShowTangDesc] = useState(true);
  const [bgColor, setBgColor] = useState("#575757");
  const contentRef = useRef(null);

  const delay = 250;

  useEffect(() => {
    updateScreenSize();
  }, [bgColor]);

  const updateScreenSize = () => {
    setScreenHeight(
      `${Math.max(contentRef.current.clientHeight, window.innerHeight)}px`
    );
    setScreenWidth(`${contentRef.current.scrollWidth}px`);
  };

  useEffect(() => {
    const debounceScreensize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(updateScreenSize, delay);
    };

    console.log("Adding listener");
    window.addEventListener("resize", debounceScreensize);
    updateScreenSize();
    return () => {
      console.log("Removing listener");
      window.removeEventListener("resize", debounceScreensize);
    };
  }, []);

  useEffect(() => {
    if (!expanded) {
      setShowGameDesc(true);
      setShowVideo(true);
      setShowTangDesc(true);
      setBgColor("#575757");
    } else if (expanded === "Tangible") {
      setShowTangDesc(true);
      setShowVideo(false);
      setShowGameDesc(false);
      setBgColor("#21423D");
    } else if (expanded === "Game") {
      setShowTangDesc(false);
      setShowVideo(false);
      setShowGameDesc(true);
      setBgColor("#1A4363");
    } else if (expanded === "Video") {
      setShowTangDesc(false);
      setShowVideo(true);
      setShowGameDesc(false);
      setBgColor("#ED7324");
    }
    document.documentElement.scrollTop = 0;
    updateScreenSize();
  }, [expanded]);

  return (
    <div className="App">
      <Router>
        <TopBar setExpanded={setExpanded} setBgColor={setBgColor} />
        <Navigation setExpanded={setExpanded} setBgColor={setBgColor} />
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Particles
          id="tsparticles"
          width={screenWidth}
          height={screenHeight}
          style={{ transition: "background-color 0.3s ease" }}
          options={{
            background: {
              color: {
                value: bgColor,
              },
            },
            fpsLimit: 60,
            interactivity: {
              detectsOn: "window",
              events: {
                onHover: {
                  enable: true,
                  mode: "repulse",
                },
                resize: true,
              },
              modes: {
                bubble: {
                  distance: 400,
                  duration: 2,
                  opacity: 0.8,
                  size: 40,
                },
                push: {
                  quantity: 4,
                },
                repulse: {
                  distance: 100,
                  duration: 0.4,
                },
              },
            },
            particles: {
              color: {
                value: "#ffffff",
              },
              links: {
                color: "#ffffff",
                distance: 150,
                enable: true,
                opacity: 0.5,
                width: 1,
              },
              collisions: {
                enable: true,
              },
              move: {
                direction: "none",
                enable: true,
                outMode: "bounce",
                random: false,
                speed: 2,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  value_area: 800,
                },
                value: 80,
              },
              opacity: {
                value: 0.5,
              },
              shape: {
                type: "circle",
              },
              size: {
                random: true,
                value: 5,
              },
            },
            detectRetina: true,
          }}
        ></Particles>

        <span
          ref={contentRef}
          style={{
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflowX: "hidden",
            width: "100%",
            zIndex: 100,
          }}
        >
          <Switch>
            <Route
              exact
              path="/about"
              render={() => (
                <About
                  setBgColor={setBgColor}
                  updateScreenSize={updateScreenSize}
                />
              )}
            />
            <Route
              path="/"
              render={() => (
                <Home
                  expanded={expanded}
                  setExpanded={setExpanded}
                  showGameDesc={showGameDesc}
                  showVideo={showVideo}
                  showTangDesc={showTangDesc}
                />
              )}
            />
          </Switch>
        </span>
      </Router>
    </div>
  );
}

export default App;
